<template>
  <div class="purchasesComp">
    <div class="div_btns">
      <button v-if="urlReport" :class="['btn_orange']" @click="downladReport">Скачать Excel</button>
      <button v-if="!urlReport" :class="['btn_white']" @click="getReport">Сформировать Excel</button>
    </div>
    <purchases-filters-comp v-show="showFilters" :showSliders="showFilters"/>
    <tbl-comp
        v-show="!showFilters"
        :model="this.$store.getters[`${this.moduleName}/getModel`]"
        :paging="true"
        :moduleName="moduleName"
        :params="onFilter ? Object.assign(filters, params,{}) : Object.assign(params, {})"
        :searchInput="false"
        :filters="onFilter"
        :searchPlaceholder="'Номер телефона'"
        :checkboxClick="checkboxClick"
        :searchMask="$helpers.input.masks.phone"
    />

  </div>
</template>

<script>
import httpService from '../http'
import api from '../api'

export default {
  name: 'purchasesComp',
  props: {
    params: {
      type: Object,
      default: () => {
      }
    },
    onFilter: { type: Boolean, default: () => false },
    required: {
      type: Array,
      default: () => [
        'date',
        'point',
        'controllerId',
        'dealer',
        'amount',
        'id'
      ]
    },
    eventId: { type: Number, default: () => 0 },
    groupId: { type: Number, default: () => 0 }
  },
  data: function () {
    return {
      show: false,
      moduleName: 'purchases',
      orders: {
        moduleName: 'orders'
      },
      usersCountEvent: 0,
      usersCountGroup: 0
    }
  },
  created: function () {
    this.$store.dispatch(`${this.moduleName}/getFilters`, {})
    this.$store.dispatch(`${this.moduleName}/setModelRequired`, { required: this.required })
    this.getCountEvent()
    this.getCountGroup()
  },
  components: {},
  computed: {
    filters: function () {
      return this.$store.getters[`${this.moduleName}/getFiltersQuery`]
    },
    showFilters: function () {
      return this.$store.getters[`${this.moduleName}/getShowFilters`]
    },
    role: function () {
      return localStorage.getItem('role')
    },
    infoMessageEvent: function () {
      let c = this.usersCountEvent
      let s = 'все'
      if (c > 0) s = c
      return `Участвуют в акции: ${s}`
    },
    infoMessageGroup: function () {
      return `Состоит в группе: ${this.usersCountGroup}`
    },
    urlReport: function () {
      return this.$store.getters[`${this.moduleName}/getUrlQRPurchases`]
    }
  },
  methods: {
    add () {
      this.$store.dispatch(`${this.moduleName}/toAdd`)
    },
    rowClick (row) {
      this.$store.dispatch(`${this.moduleName}/toUpdate`, { id: row.id })
    },
    checkboxClick (row, col, checked) {
      if (col.data === 'userEvents') {
        let data = {
          userId: row.id,
          eventId: this.eventId,
          add: checked
        }
        this.setUserToEvent(data)
      } else if (col.data === 'group') {
        let data = {
          userId: row.id,
          groupId: this.groupId,
          add: checked
        }
        this.setUserToGroup(data)
      }
    },
    async setUserToEvent (data) {
      try {
        let result = await httpService.post(api.events[this.role].setUser, data)
        let count = result.data.count
        this.usersCountEvent = count.users
      } catch (err) {
        console.log(err)
      }
    },
    async setUserToGroup (data) {
      try {
        let result = await httpService.post(api.groups[this.role].setUser, data)
        let count = result.data.count
        this.usersCountGroup = count
      } catch (err) {
        console.log(err)
      }
    },
    async getCountEvent () {
      try {
        let count = await httpService.get(api.events[this.role].count, { eventId: this.eventId })
        count = count.data.count
        this.usersCountEvent = count.users
      } catch (err) {
        console.log(err)
      }
    },
    async getCountGroup () {
      try {
        let count = await httpService.get(api.groups[this.role].getUserCount, { groupId: this.groupId })
        count = count.data.count
        this.usersCountGroup = count
      } catch (err) {
        console.log(err)
      }
    },
    getReport () {
      this.$store.dispatch(`${this.moduleName}/getQRPurchasesReport`, { params: this.filters })
    },
    downladReport () {
      let url = `${this.$http.server_api_url}/${this.urlReport}`
      window.open(url, '_blank')
      this.$store.commit(`${this.moduleName}/setUrlQRPurchases`, '')
    }
  }
}
</script>

<style scoped lang="scss">
  .div_btns {
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: auto auto auto auto;
    grid-column-gap: 10px;
    margin: 32px 0 0 32px;
    width: 400px;
  }

  .label_info {
    float: right;
    margin: 5px 32px 5px auto;
  }

  .btn_orange {
    width: 100%;
    height: 36px;
    object-fit: contain;
    border-radius: 9px;
    background-color: #ff8200;
    object-fit: contain;
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: -0.5px;
    color: #ffffff;
    cursor: pointer;
  }

  ;
  .btn_white {
    width: 100%;
    height: 36px;
    object-fit: contain;
    border-radius: 9px;
    background-color: #ffffff;
    object-fit: contain;
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: -0.5px;
    color: #ff8200;
    border: 2px solid #ff8200;
    cursor: pointer;
  }
</style>
